import { render, staticRenderFns } from "./suZhouBank.vue?vue&type=template&id=a960562e&scoped=true&"
import script from "./suZhouBank.vue?vue&type=script&lang=js&"
export * from "./suZhouBank.vue?vue&type=script&lang=js&"
import style0 from "./suZhouBank.vue?vue&type=style&index=0&id=a960562e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a960562e",
  null
  
)

export default component.exports